import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

/** Global footer with legal links and copyright. */
export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
        width: '100%',
        py: 3,
        flexWrap: 'wrap',
      }}
    >
      <Box sx={{ display: 'flex', gap: 3 }}>
        {/* TODO: point these at the real Terms / Privacy routes once they exist. */}
        <Link
          href="#"
          underline="hover"
          variant="caption"
          sx={{ color: 'text.primary' }}
        >
          {t('footer.terms')}
        </Link>
        <Link
          href="#"
          underline="hover"
          variant="caption"
          sx={{ color: 'text.primary' }}
        >
          {t('footer.privacy')}
        </Link>
      </Box>
      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        {t('footer.copyright', { year })}
      </Typography>
    </Box>
  );
}
